import isEmpty from 'lodash/isEmpty';
import apiServiceHotels from '@api/apiServiceHotels';
import factory from '@helpers/storeFactories/factory';
import providers from '@store/modules/hotelDetails/providers.js';
import normalizeHotelReservation from '@/data/response/normalizeHotelReservation';

const STORE_NAME = 'hotelDetails';

const store = factory.createStore(
    STORE_NAME,
    {
        get: apiServiceHotels.hotels.hotelReservation.get,
    },
    {
        normalizeItemFn: normalizeHotelReservation,
        statePath: 'reports.hotelDetails',
    },
    {
        getters: {
            hasEmptyListFilters: (state) => isEmpty(state.listFilters),
        },
        modules: {
            providers: providers,
        },
    }
);

export default store;
